import React from 'react'
import { useParams } from 'react-router-dom'
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb'
import {
  IndexAdditionalInfoSVG,
  IndexAdditionalInfoSection,
} from 'src/components/Reusable/IndexPage/IndexPage.styles'
import { DirectRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { dateWithinWindow, formatTimestamp } from 'src/Utils/formatDate'
import { DateLimitWarningContainer } from '../Roadmap_v2/roadmap.styles'
import { DATE_LIMIT_WARNING } from '../Roadmap_v2/roadmap.constants'
import {
  AccountSettingsLink,
  DateLimitInfoContainer,
} from './AccountSettings.styles'

export const DateLimitInfoSection = ({
  dateLimit,
  slidingMonths,
  onClickHandler,
}: {
  dateLimit: Timestamp
  // The account's sliding window length, or 0 when it is on a fixed date.
  slidingMonths: number
  onClickHandler?: () => void
}): JSX.Element => {
  const { pageContext } = useParams()
  const settingsLink = `/${pageContext}/${DirectRoutes.ACCOUNT_SETTINGS}`
  // A sliding window is never stale by definition, however far back it reaches.
  const isOldDateLimit = !slidingMonths && !dateWithinWindow(dateLimit, 365)

  return (
    <DateLimitInfoContainer>
      <IndexAdditionalInfoSection>
        <IndexAdditionalInfoSVG />
        {slidingMonths
          ? `Considering evidence from the last ${slidingMonths} months, since `
          : 'Considering evidence since '}
        {formatTimestamp(dateLimit)}.
        {isOldDateLimit && (
          <DateLimitWarningContainer>
            &nbsp;{DATE_LIMIT_WARNING}
          </DateLimitWarningContainer>
        )}
      </IndexAdditionalInfoSection>
      <AccountSettingsLink to={settingsLink} onClick={onClickHandler}>
        Change in settings
      </AccountSettingsLink>
    </DateLimitInfoContainer>
  )
}
